import { TargetedAtType } from "../../../js/enums";
const New = (listType) => {
  var nameAttribute = "";
  var nameAttributeText = "";

  switch (String(listType)) {
    case String(TargetedAtType.Account):
      nameAttribute = "name";
      nameAttributeText = "Name";
      break;
    case String(TargetedAtType.Contact):
      nameAttribute = "firstname";
      nameAttributeText = "First Name";
      break;
    default:
      break;
  }
  return {
    BackgroundColour: "#ececec",
    ContentBackgroundColour: "#fff",
    ContentPadding: "0 15px",
    LinkColour: "",
    Padding: "20px",
    Rows: [
      {
        Columns: [
          {
            Controls: [
              {
                Name: "Text",
                Template: "text-control",
                Properties: [
                  {
                    Name: "text1",
                    Value:
                      '<span style="font-size: 12px;"><strong><em>Enter a preview of your content here</em></strong></span>',
                  },
                  {
                    Name: "text2",
                    Value:
                      '<div style="text-align: right;">\n\t<a href="actions/redirect.aspx?url=../home.html" style="color: rgb(0, 0, 0); font-size: 12px; text-decoration: underline;">View email in your browser</a>\n</div>',
                  },
                  {
                    Name: "backgroundColour",
                    Value: null,
                  },
                  {
                    Name: "padding",
                    Value: "10px 10px",
                  },
                  {
                    Name: "margin",
                    Value: "",
                  },
                  {
                    Name: "columns",
                    Value: "2",
                  },
                  {
                    Name: "columnSplit",
                    Value: "50",
                  },
                  {
                    Name: "showOnMobile",
                    Value: "1",
                  },
                  {
                    Name: "textColour",
                    Value: "",
                  },
                  {
                    Name: "fontSize",
                    Value: "14px",
                  },
                  {
                    Name: "fontWeight",
                    Value: "normal",
                  },
                  {
                    Name: "lineHeight",
                    Value: "100%",
                  },
                  {
                    Name: "textAlign",
                    Value: "left",
                  },
                  {
                    Name: "borderType",
                    Value: "none",
                  },
                  {
                    Name: "borderThickness",
                    Value: "",
                  },
                  {
                    Name: "borderColour",
                    Value: "",
                  },
                  {
                    Name: "stackColumns",
                    Value: "0",
                  },
                  {
                    Name: "fontFamily",
                    Value: "Arial, Helvetica, sans-serif",
                  },
                ],
              },
              {
                Name: "Text & Image",
                Template: "image-text-control",
                Properties: [
                  {
                    Name: "src",
                    Value:
                      "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAZABkAAD/7AARRHVja3kAAQAEAAAAZAAA/+4AJkFkb2JlAGTAAAAAAQMAFQQDBgoNAAACmQAABq0AAAgKAAAJDv/bAIQAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQICAgICAgICAgICAwMDAwMDAwMDAwEBAQEBAQECAQECAgIBAgIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMD/8IAEQgAMgDIAwERAAIRAQMRAf/EAKgAAQACAQUBAAAAAAAAAAAAAAAGBwQBAgMFCAkBAQAAAAAAAAAAAAAAAAAAAAAQAAIDAQABBQEAAAAAAAAAAAUGAgMEAXAwUGARFgcRAAEEAQMDAgQHAQAAAAAAAAMBAgQFBhESEwAiFCEVMiMWBzBQYDFBUWIzEgEAAAAAAAAAAAAAAAAAAABwEwEBAQACAQUBAQAAAAAAAAABEQAhMXAQMFBgUUGR/9oADAMBAAIRAxEAAAH7cAAAAAAAAAAAAAAAAAAAAAAAAAAAAjJ5mOYtQ7gihjkmIadsSc3GhZwAAAAAKtKDMEugqwvc87FvlWGARknRapeYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB/9oACAEBAAEFAveCsTMs9L6dn2x9M5rFk8R2koOK5Z1xZ9IPdvOsMCCmx2HBAt9xQFY/6SoEJ6W8LjKdcF37VS+srh9Rv0s2cRUsksmG5QYdRBVFEuGsysx1PTHfpjwGnsCdWrLWvKurYsru12pbBJbPqTib3SV2P90i1SnR8R//2gAIAQIAAQUC8X//2gAIAQMAAQUC8X//2gAIAQICBj8CL//aAAgBAwIGPwIv/9oACAEBAQY/AvzhjKQtZHluM1CSLWPKmRwR9hNxGQ4kqCSUZCbdGc4U017v7fQeLUFypc3PhseWJkttEVkakbkcy7WGsl8xEg1SqhInk7ufRvLouqS8bNFqjZiLKqzGIpBJKDTSQ29W+9jXz4bpEieAEaqjn5Y/M7UwNiG70VMix67bBW4xs1cpJdYM0eDY19vFfJr5ooUmTMkQSK4BhEE4xkR4tUeqL6Bayw3FPemxocZIc/zPeoyEeeG+F4vlhQQRqVxXsQKB0Ju41Ry45WxJtDWlvJFij52Q8nhBDXxEMrWNHOr98g8gw2NTk/lfResfxeASiJkFpX2lxYWj4c4lRAqqwsQCHDVsswy5JJkmyCJieY1E0e/X0Rqy5NiIEKwprO2pLsYCOJDHOpZLwSDxnk0L4kkLWnYj+5rCIi66arj0zICvBZZhHn3GP08Grspk01WN0Y8eKwEIMwhp8atsI7z/AA+qvciINjttc2LYSSMs5rKsEl1RcChhtyPcMVNPmGgsjV1uQjFRI5nMLrpqnezcKplrZRjHmgrQyz0lyKpLZStviwR3D4KVjzyN6IzQu1z+zXf29OZ7ivM2++l1jpDnLMS8VvIkNIXirKVFj/OQuzg8f5u7j7upo7FoktKa4saOxUDHDAY0EuseYIT3kcJlhXGCfZquzk01XTX8VzcTrUn2skzI3K48ITa2OTXnsUFOlRBTTx2f8g72o4ipuXai9YtNqcZnxrDDcgk2bodrb08myyUN3XWNfkMt1hHmniOt5DrLnRTvExz2bOxqptk5z7WwN+mY1F7Dx4k+HzuoqmhPjbq+ROE81aO2lxp8iSmhXBaTjHy6bndZVlNrBWqkZESojRaskiLKlRaqiiFFFdPLBLIhJNkypx3uYIpWMYrU3uXXpM/dXw+SfOk0cyj5Ye+FjShjx4mRMlo7iJkDjQGukNRy7oJGhTuEm4YB4cfKxHEZj0YfHxgjuftbxy2Xk+GvjGT41E0zkRPgXrCrQEH32ZT0d/jtzVwJsUZhV11ax7yvFUHti10SQKiNEbF0IQKvB3J8O1buNboOLY5VZ5Fc2YIxfJHAJfmLxxBn2jSQ6DB4hueiI15GqqenX2ssXRWibh2O5TjORtUjWOh3AwUFUgxiJtMYJz1BXje1FRRK137ORVt65Io/Ll/dsmWAZ5UfR1I7N490khX8m1pPbxq7jXv19NNepvmV9lOkhzuot6uzfkrAY6HFIN3AlAhwqAdm1vu8aEJedTw28jmq5pnO2M6b9wvb4aEScuPvo+WHv+luLx0ydZm7h+o2m7tuuvty+Prv6yK72KMOT5TY3MJHI5riVw4tfR18va71RlhEpmyGf4Kn6S//2gAIAQEDAT8h+YojEiCMuSiW0oGR1Y5ux5rLhi+13WKNoh7X4yxsoATuEuQAM4QKvr7woeBubEjuXf4qrjoxDJ5ek5xC11QjMI+84zMBlLAWQMsgLW/0Gl9PTh3RbAuBfiOXOqxuzXvSmRoOM77aMJEqWeaLkSOqGGuZAL3ACOgTT9pyNgyLTkNG9oRL3KuWXS8LIKQW4hkhf+3OLoi52MWUTeTAhtlQ3ZB0XIIQ/wDncHjgG3iZ9fLg5chC3AGH9ZqQGRzrAHkV9Pwu9x/+GRgbUohL8uGeZS51cUq02gEgtys04j+1doz84xdBw9LavgqfUv/aAAgBAgMBPyHxf//aAAgBAwMBPyHxf//aAAwDAQACEQMRAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEkAgAAAAAAAAgAkEAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH/9oACAEBAwE/EPmGZJG7lIY3+h1sjRYtPsnHJEFNti+qNosG0xq74RM+FDtUzsLcqDLm6y9dOXDI0Rue1xQa2u/a+T4TLgFvw7LYoC/TmgGUdtHEhQ91NKAYYwYuwuy0OEuDbMzmmoxyniG/njL4DV3hYlX+chX+6xTE0GKjicQfTOxKnfHAlx9vAhMrji5oEK/uOQ9rukzzLagQQWnTU5UIL+1sHvhoGgBmTKphR7ozOIP2ehZHmYvh43kAXVjOEWtEPsTG9Re04M7QmXTuxorrEbdVMAQ8dX9YibuEmWJGhPTMoQCIbKUAfUf/2gAIAQIDAT8Q8X//2gAIAQMDAT8Q8X//2Q==",
                  },
                  {
                    Name: "width",
                    Value: "200",
                  },
                  {
                    Name: "height",
                    Value: "50",
                  },
                  {
                    Name: "text",
                    Value:
                      '<div style="text-align: right;">\n\tPlease enter your text\n</div>',
                  },
                  {
                    Name: "altText",
                    Value: "",
                  },
                  {
                    Name: "backgroundColour",
                    Value: "#ddd",
                  },
                  {
                    Name: "padding",
                    Value: "15px 10px",
                  },
                  {
                    Name: "margin",
                    Value: "5px 0",
                  },
                  {
                    Name: "verticalAlign",
                    Value: "middle",
                  },
                  {
                    Name: "textColour",
                    Value: "",
                  },
                  {
                    Name: "fontSize",
                    Value: "14px",
                  },
                  {
                    Name: "fontWeight",
                    Value: "normal",
                  },
                  {
                    Name: "lineHeight",
                    Value: "100%",
                  },
                  {
                    Name: "textAlign",
                    Value: "left",
                  },
                  {
                    Name: "borderType",
                    Value: "none",
                  },
                  {
                    Name: "borderThickness",
                    Value: "",
                  },
                  {
                    Name: "borderColour",
                    Value: "",
                  },
                  {
                    Name: "imageAlign",
                    Value: "left",
                  },
                  {
                    Name: "stackColumns",
                    Value: "0",
                  },
                  {
                    Name: "showOnMobile",
                    Value: "1",
                  },
                  {
                    Name: "textPosition",
                    Value: "ltr",
                  },
                  {
                    Name: "showButton",
                    Value: "0",
                  },
                  {
                    Name: "buttonText",
                    Value: "Button",
                  },
                  {
                    Name: "buttonWidth",
                    Value: "auto",
                  },
                  {
                    Name: "buttonAlign",
                    Value: "left",
                  },
                  {
                    Name: "buttonColour",
                    Value: "#ddd",
                  },
                  {
                    Name: "buttonRadius",
                    Value: "0",
                  },
                  {
                    Name: "buttonPadding",
                    Value: "5px 30px",
                  },
                  {
                    Name: "buttonMargin",
                    Value: "5px 0",
                  },
                  {
                    Name: "buttonTextColour",
                    Value: "#222",
                  },
                  {
                    Name: "buttonTextAlign",
                    Value: "center",
                  },
                  {
                    Name: "buttonFontSize",
                    Value: "14px",
                  },
                  {
                    Name: "buttonFontWeight",
                    Value: "normal",
                  },
                  {
                    Name: "buttonBorderType",
                    Value: "none",
                  },
                  {
                    Name: "buttonBorderThickness",
                    Value: "",
                  },
                  {
                    Name: "buttonBorderColour",
                    Value: "",
                  },
                  {
                    Name: "linkType",
                    Value: "",
                  },
                  {
                    Name: "selectedLinkAttribute",
                    Value: "",
                  },
                  {
                    Name: "link",
                    Value: "",
                  },
                  {
                    Name: "emailAddress",
                    Value: "",
                  },
                  {
                    Name: "emailSubject",
                    Value: "",
                  },
                  {
                    Name: "emailContent",
                    Value: "",
                  },
                  {
                    Name: "predefinedLinks",
                    Value: "",
                  },
                  {
                    Name: "buttonLinkType",
                    Value: "",
                  },
                  {
                    Name: "buttonSelectedLinkAttribute",
                    Value: "",
                  },
                  {
                    Name: "buttonLink",
                    Value: "",
                  },
                  {
                    Name: "buttonEmailAddress",
                    Value: "",
                  },
                  {
                    Name: "buttonEmailSubject",
                    Value: "",
                  },
                  {
                    Name: "buttonEmailContent",
                    Value: "",
                  },
                  {
                    Name: "buttonPredefinedLinks",
                    Value: "",
                  },
                  {
                    Name: "fontFamily",
                    Value: "Arial, Helvetica, sans-serif",
                  },
                  {
                    Name: "buttonFontFamily",
                    Value: "Arial",
                  },
                ],
              },
              {
                Name: "Image",
                Template: "image-control",
                Properties: [
                  {
                    Name: "src",
                    Value:
                      "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAZABkAAD/7AARRHVja3kAAQAEAAAAZAAA/+4AJkFkb2JlAGTAAAAAAQMAFQQDBgoNAAAHjAAAEO4AABedAAAaGf/bAIQAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQICAgICAgICAgICAwMDAwMDAwMDAwEBAQEBAQECAQECAgIBAgIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMD/8IAEQgBLAJEAwERAAIRAQMRAf/EALgAAQACAwEBAAAAAAAAAAAAAAAGCAIFBwkEAQEAAAAAAAAAAAAAAAAAAAAAEAACAwABAgYDAQAAAAAAAAAFBgMEBwIBCCBQoLAREgAQYBYRAAEEAgECBAQCCAYDAAAAAAIBAwQFEQYSIRMAIhQHMUEyFVEjIFCgYUJiMyRggZGhUhZTRBcSAQAAAAAAAAAAAAAAAAAAALATAQEBAQACAAYDAAAAAAAAAAERACExQRAgUKCwYWBRcf/aAAwDAQACEQMRAAAB9uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACoZJSCkhIqT4s4AcFOTm4MT5TblryrBacAAFZixBsQAAAAAAAAAAAAAAAAAAAAAAAUyPnK+kwNwYlyzy/PV40JQUmJiZGJfAq8UvNsdZNeb84cX3NeWeAAAAAAAAAAAAAAAAAAAAAAABVs5ic8J2Rg6SWFPP09JTjxX8+8+o1JIy8ZS81QBxknpATuxYo6oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACBE9AABBCdgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//9oACAEBAAEFAvR4vzq2iWdSv6rZKEHtyPNCO+GirFd0BwYmbPH6y2Sftru6Lwuqmhs3+2a385walB/OztbA/slxuRX8qXP/AImHi7c0+LUCp5ZD1LVe/U8wcEZ2IvKToTJK3crLDQ1fJCHS6+dtXzMlC/tD3LNizRbwETO8naQUPRACmiRqiGo1m9HrWWfNrWNE+0G24h8zsrF9oe5EtZ50hWC1+MGU4ghUNDRs4VJWo1mPCZO1V1GYrOw4xZ5u6B0Z3hYq9U4YuZnjFuW7l3mB3Rii8YUQLM0aKvdGfHjywGYW7ThPBjx5izRaPTMrmaJAFy1kbEFVwBOYyGZ3susF6Q5n0fSDg1hz/SVwQwO+k2KbDl2gJYJgZdBli4TxYZzkGrfbwCMryDlgIyLfgwIzD3BZ1Ybcy45bWaEpf6ZGxG1NjdiPLG0cFyWU/wDgI1oRCxeIstiTlz0eX//aAAgBAgABBQL2tb//2gAIAQMAAQUC9rW//9oACAECAgY/Ai1v/9oACAEDAgY/Ai1v/9oACAEBAQY/Av2PHWtS0upprS1u4FtYPpcuymWmWIHZ7ai4w4yAc/zPqUsrhOnzJvc6LVq2o9K6QyKadJkS/WIbXZbVt6Q4PZIFPK4+SeL3Vfbep191dX9O1eX+1yLAKsJ8hCJK6JFq09Y86CNkinnCEK5RE4qd5o241MKq2yjiM2XOpfekVFtVvEyHroKyMvsi2cltFEyJfP8AJUIUvNa9sqnX5QauaR73YNofsAqvuXIhKqhMVmJTkhomjEj6ihCucJxU76kvasaLbdWlhEuq1t71EYwd5ennQXV6nGf4L0yWOi8lQk/QjQdJpNcfYcik9JvNlspTcKNI7pAML7bXN+vdJW0Q+4KqPXC46Zd9vN/p6qvv3K37tU2NA9JcqLSIHd7nbbnEUtpfyHMKq/Fo0VEwmWNA0KqrrbaFg/c7SZcvSGaPX4K8Oy5YJDT1b7j3dDygqKiGH1cukzQN7qa6p2hmvG2rpVM++7S3ldyUHHYQy8ymTbIS6GqqSAfQeHWRont1VVFjc1cRubf3GwPTG6GmR8UKPDcGvT1cmW8JivkXpnGF4nwu9J3CpiUu4UTDU4grn3JFVbVj3axPrjey8AgT4cgJSXzp80MR8bfbDLNrUaKaWq0kAAa7djZQCQrm7ee7ffcEXSRpjifaUMrjkmf04e30shwo2uWEeTsVOjbTjdxr0hwI08R5tq4zMgo4jzZiYoiCXLl8PEadEcF6LMjsyozw/S7HkNi6y4P8ptmi/rGJuup3tDWPwdbWhjsW0B+blXJkmXIe8g4ZV3ugGU5Kgov4+J3t37gVddA2aPB+511hTG8tTdQUXzGwEkieA+OVRc+bgaKLajhdtc9nmG9gCWrJ79X2ohG16Dds9wQSDcerZe+5vErvcbQCQHOWeaeVrcJG6DMge6smM0zKqJMZqNXQtejEx2Y+vuNSpaTo5cWnHXFLJ9CHknMyvZ7w4nz90uZE8lwrnqFjVuQMvj5M/D+ZV+fjZRjp5JmgRnrBEX+Np6laZeJEVE7gi2AJn+Ev3+LGgnk401OZUW5TBKMiFJHzRpjBCQr3I7qIuM4JPKvRV8R/Yh4nom4x551Gw7Khcmx0qGy0+lm04pNuuy58J0G+vmcD4rzdyMCmrQJuFXRwjMIZq46oj9TjzpeZ1941UzJfqJVXwhafGpZdt6lpCavnpbEL0nFzvEhw0V3vofHj8sZ8SXPdNl+J7h2FOcXVRYCP/wBWSkaV59+PSvtSJL5S14ul+avJEVxF8y9ffCZKH+8YtKKEyRY5pCH7s0CD8+BswWP9E8ezciKn908N7FeVF8yw+woGhYVF4i1KeXx7zzpA4nO77Ljv5xzBmLKs0jsfjwZ7hCnjQSjphZmmWrE/C/GM01sbzCmiKn/sgKZXP+3SzmN/1IlfMkt/D62I7jo/FCT6h/DxqxJknJQ2syQ4XU3X5FzYERmq/USDgc/gnh1/dJtpcVkKznV1PTJZzocKAvFmZJnmkN5gpc16RM8quqYgIImOuPG9aBtF9dXOm+31wcOvp3LGXFWwSxkzmY33OZDdjyn40BioVQZQkbRx4lTCdPG7+2MOZMlazFpomxUsabIOSVVy+1C9EYM1yLJLbYx1yjQqvm5ZtWthlbHs+1vPm+sGpnbPdTqMv/DDjVBLArhjLji09lQ6dMeNn1jYn7C0h1t5aa4zJsCeatiqezGehpIcc/uWLCEbi8VXBNcRRPp8TPYtpX5m3SZ7NXqOxmXFv/qFiEh56zedUlcCRVQ2DEcZJvPlyrKcrbU46uSIoazcR5Ul9VKTOfk18j1c14iI17rzhKqJnDaYEegp40t55ckFQkRM9fyoEiRAYT4J8GYw/rGdXSPbberWC0rSV1vrVexdsWHOO044TrLT7JV4tvkQeZSVeOcJnCP+6G0Up6zFg0v2DV6OW425bemJx5x2fZI2mIxF6t7AL507mPpBCPb4krTtj27Wtju5F/WXGpwxt7JpyUpZiWEDusucgDiimqinJFUeSF5f/p1xQzNTqqug+wUVZaKAXVj3HJRuTbCI0RJEEEnOJwNc54YzhV8bVEa1LYdr0rZ7V3YaZ3VIg2U2osZWAl18yApsqDPEWxR3lhG2hXzKpIG2+5e1wCqLbaexBqqQ3BckVNDCRptoJih5ElSUiMqopjCgpKiKeEsLClp5t9bi32qytgxnpROzXUUWXJAsopBDYXzuL06JhF5Knis3aqedl+71ZZvbZaPovNblyx4LZ6+QNkiOssxU4AA+U17oiid7pX2cmtm00mXHByTV2LRsy4Mj6X47gmIKSA6K8TwiGOC+fj0pe323X9MsVlxu41eNHuHSlGriOxiqweafaBlEHzkSZyvlwmV1ncrLWrHUdW02PMKuj3qDGvrafNAh5OQGzI4LLZI2qieejeMlz8lhv1Jr9ltGt7ZXxomy1dE0km4r7GCLYR7CJX5BZgm018EL6nHOXHyZY9x76isNZpNcqXarVai4EWbiTJmC+MuznQhJz0idiY4HFV+PDGeJL42XZa3WrnatO3nsTbGLrcdJ91T3kbuKTw16k2shiY5IdJVRRT8zquW0Q7P3R2aola8w1Uhr2p0dgo/c2YPJXJM+e0GUim4bjnFvOfzi+SCROMuJlt1s2jT8QcFRJP8ANF8WujzVxZ6JsNpUPtl/UOFMlvWdbOROi+nmhJPtr8xDw9AvaybUzV2CxkJFnsHHfVhyNXiDvbcRC4ETa4X93j3mn2NZNhQrnYK6RVSpLBtMWDDcnYiN2I4SILwAMgMqn/JPG2bA7WTW6SXpUaFGtSYNIL8sXNZUo7UjHbN5EjOdP5F8bLrFh7d7Psd9YX8yxibJUxoxVF56gGhYO0vJDrTcBrmKuZLmod0sgJcs+5c2912xk3JbdbWkaurYcoxu3X22QbOnImlJ2BJlovFzHka8xeJ262bzsb3en2TO3Vz4r2Tqjghmt1kBMlFltYycVFccHeAnlG1za3NzTTqLY59U9r/2aVGeYklfWg/amVgMuj3JDLpyO+3jl+WiovUS8a3QuY71XTwo0rC5FZiMiUxR/lKUR4/d/gGRtTLBM3Myuaq5r7TzoNTYrDncY9VFQvTvSGMYB1R7gh5c8en6dLOtGDlOa/NWyrGifeGI1YdtWm5jsUDFmTIjCS9pXELtqqqOF/Y8/wD/2gAIAQEDAT8h+zxr60j+PyArBkZGnXDwCDSdg9MnD+9o+euhXAHIeoqQtRYMO4DobdMXGwDF+1Mrc9L/AM9GfYfyHbmxnhBgpRExbaUbNjisHSmhzeZgm43RKOZoUa8qw+qa9xbAmT+TvQrkpnvzDscgIQ0hdhp0PhM29NaxqQvUt8+LIypwZJIdTEzuJf12piiH6fqJAVDNb0kHxBdC/F3Ddlv5QYt/VI0gl4UBdYHN+yUfq7HhG0MkAqdEmYcpouCDyzE9UCTYIlAxOeW9xb5Xfi5RmpnsQrVH0mRAiSZJre7VfaAjLPOjfEAvmkiXmq9btEArbEEHc1MxhjoYDcTsUOeT1kJaeKwCcxeVePjIYd9C7me6vOf3chCsWE7XPOCoHo5PNu3HfeZHyj9ZokSlBhKDZ1G9w49uJ4e/ZXEQ415cCuaY2zbYGTLn6L16vqWlyytkUVeemYmgVevaUE8h4Rid5tZry6GbaQgtErT1LKi+wMhR2CjVdYHAwPQe/P1ErHqU5BMT8XnefoTmUvfNtsN3/R1LjqCfeJ6uaRLbN7HoOtX5JSQlUYkjvVpIbobndqEktvtr2pIHCbe42qLk7s4pTGFyeupp6W/jlMAjIeybh2osfcYt8c9WplidxQWmerRc6oIOi2umg0QJtGIdDIvUCywbEujuOBPNkBAPjzE+0Wpn9h1GnYY6VZPj1TjNKZfnJyGNKIHASYz4FWdeqnVVmdIH92UWVvqL2KLf8XHXiiQvmBLNCDei4Ic5hdl4IDIsApIUkryLi2vN8+EsEG9hFzdVklgXq9t+w/gI3/EFFoCJST889lEPwZgiYoF+zz//2gAIAQIDAT8h/Frf/9oACAEDAwE/Ifxa3//aAAwDAQACEQMRAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkggAEgAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAEkEEAAgkkAkgAAAAAAAAAAAAAAAAAAAAAAAAEEgAgkkAAkkAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//9oACAEBAwE/EPs8aeB+Cg92gmKOSax83aGQBQAtO/MQ0dSHzStjBPQLaB/cYWT4jeBXH/U4Td0Ul61T5UqZrHxF4VVbDtAGCOYzremb/wCnFk5eVTTTwJUb5mOGjG0UIh+ai3N6FkPtEShbas9FyUlPFCYhfBipFvX/AIGbwI6PmZ3cuFQVvPI+osS0A+IZoKP1FfBw9dzLjjz1RjIL6Bva6GIxwoXcWSAE1sMqFQg2A6OFDBEvOASuwVXoQOzTLIOqNKQQgQEfwQXkgLyDfbQvS3h9y+jTXH7H7W1Sx2HpZ1VTbOmJ1Sj6MYpAaIcj5/CQP+ij4Ui1oEGkRCZl3p7Wwl0iKGjZI9ii+wUOcJhcoNe0ecYyXYZ4HdA30Kr9kjjbn4O3k5AqqSsQnTa4r0ZDCyVDZgGlzhrgGg7UKlHSOsQN5NFdC1k0fIWAZK9UEzQdBIkFttqODSjjDFBSv9OlMq7hIAc9CAwBJCKAVFfUCsLv+bbGF1wYVllngQxJcwY40oQi0rpk2FSZXkITRn3qILxgOtTP+A66C5h3bUG8PQ2wAM5renVAS2DkEuc1t+GnYSAzyI04GdPkiLogWP8AnCWkNbzZlBjeGkDImpTKqPwRPYPoak5zlE1cu8DlWqPgMSdEvBaRYWMBdGSRWx8QXyfZZ6yq5BqIlwg3aqeWgkEGSEsHTcb0EyCHjmxdvkuRDKGvNLZ8fUJMBcnDxY5Gi6Aj6j+4J80BCNJa3qwK8OFV1ICLZhhUlPNxDjVtt4Gzbdn71pDqADh/ASZwTJda1kEO38zuMCCW4UweST7PL//aAAgBAgMBPxD8Wt//2gAIAQMDAT8Q/Frf/9k=",
                  },
                  {
                    Name: "width",
                    Value: "576",
                  },
                  {
                    Name: "height",
                    Value: "297",
                  },
                  {
                    Name: "altText",
                    Value: "",
                  },
                  {
                    Name: "backgroundColour",
                    Value: null,
                  },
                  {
                    Name: "padding",
                    Value: "",
                  },
                  {
                    Name: "imageAlign",
                    Value: "left",
                  },
                  {
                    Name: "showOnMobile",
                    Value: "1",
                  },
                  {
                    Name: "linkType",
                    Value: null,
                  },
                  {
                    Name: "selectedLinkAttribute",
                    Value: "",
                  },
                  {
                    Name: "link",
                    Value: "",
                  },
                  {
                    Name: "emailAddress",
                    Value: "",
                  },
                  {
                    Name: "emailSubject",
                    Value: "",
                  },
                  {
                    Name: "emailContent",
                    Value: "",
                  },
                  {
                    Name: "predefinedLinks",
                    Value: "",
                  },
                ],
              },
              {
                Name: "Text",
                Template: "text-control",
                Properties: [
                  {
                    Name: "text1",
                    Value:
                      '<div>Hi \n<span class="crmattribute" contenteditable="false" data-g4-formatstring="" data-g4-defaultvalue="" data-g4-attribute="' +
                      nameAttribute +
                      '">' +
                      nameAttributeText +
                      "</span><br />\n<br />\n\tLet's start creating your communication, it's really simple. To start editing just click on a section or drag in new content sections from the right. You can also rearrange content sections by dragging them to where you want, or simply delete them if you change your mind. At any stage you can adjust the overall style of the communication or change the layout by going back and selecting another option.\nHave fun!</div>",
                  },
                  {
                    Name: "text2",
                    Value: "Please enter your text",
                  },
                  {
                    Name: "backgroundColour",
                    Value: null,
                  },
                  {
                    Name: "padding",
                    Value: "5px",
                  },
                  {
                    Name: "margin",
                    Value: "",
                  },
                  {
                    Name: "columns",
                    Value: "1",
                  },
                  {
                    Name: "columnSplit",
                    Value: "50",
                  },
                  {
                    Name: "showOnMobile",
                    Value: "1",
                  },
                  {
                    Name: "textColour",
                    Value: "",
                  },
                  {
                    Name: "fontSize",
                    Value: "14px",
                  },
                  {
                    Name: "fontWeight",
                    Value: "normal",
                  },
                  {
                    Name: "lineHeight",
                    Value: "125%",
                  },
                  {
                    Name: "textAlign",
                    Value: "left",
                  },
                  {
                    Name: "borderType",
                    Value: "none",
                  },
                  {
                    Name: "borderThickness",
                    Value: "",
                  },
                  {
                    Name: "borderColour",
                    Value: "",
                  },
                  {
                    Name: "stackColumns",
                    Value: "0",
                  },
                  {
                    Name: "fontFamily",
                    Value: "Arial, Helvetica, sans-serif",
                  },
                ],
              },
              {
                Name: "Text",
                Template: "text-control",
                Properties: [
                  {
                    Name: "text1",
                    Value:
                      '<div>\n\tYou have received this email as you are subscribed to the [Insert Company Name] mailing list. You can \n\t<a href="/actions/portal.aspx?type=update&email=$$attribute:emailaddress1-$" style="text-decoration: underline;">update your details</a> or <a href="/actions/portal.aspx?type=unsubscribe" style="text-decoration: underline;">manage your subscriptions</a> at any time.\n</div>\n<br />\n<div>\n\t<a href="/actions/portal.aspx?type=unsubscribe" style="text-decoration: underline;">Unsubscribe</a> from future communications.\n</div>',
                  },
                  {
                    Name: "text2",
                    Value: "Please enter your text<br>",
                  },
                  {
                    Name: "backgroundColour",
                    Value: null,
                  },
                  {
                    Name: "padding",
                    Value: "5px",
                  },
                  {
                    Name: "margin",
                    Value: "",
                  },
                  {
                    Name: "columns",
                    Value: "1",
                  },
                  {
                    Name: "columnSplit",
                    Value: "50",
                  },
                  {
                    Name: "showOnMobile",
                    Value: "1",
                  },
                  {
                    Name: "textColour",
                    Value: "",
                  },
                  {
                    Name: "fontSize",
                    Value: "12px",
                  },
                  {
                    Name: "fontWeight",
                    Value: "normal",
                  },
                  {
                    Name: "lineHeight",
                    Value: "100%",
                  },
                  {
                    Name: "textAlign",
                    Value: "left",
                  },
                  {
                    Name: "borderType",
                    Value: "none",
                  },
                  {
                    Name: "borderThickness",
                    Value: "",
                  },
                  {
                    Name: "borderColour",
                    Value: "",
                  },
                  {
                    Name: "stackColumns",
                    Value: "0",
                  },
                  {
                    Name: "fontFamily",
                    Value: "Arial, Helvetica, sans-serif",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };
};

export default New;
